import { GlobalSearchType } from "@/graphql";

export type GlobalSearchUIType = GlobalSearchType;

export const primarySearchTypes: GlobalSearchUIType[] = [
  GlobalSearchType.SQDC_EVENT,
  GlobalSearchType.SQDC_ACTION,
  GlobalSearchType.KPI_BOARD,
  GlobalSearchType.KPI_TILE,
];

export const additionalSearchTypes: GlobalSearchUIType[] = [
  GlobalSearchType.QUICK_TEMPLATE,
  GlobalSearchType.WORKFLOW,
  GlobalSearchType.CHART_TEMPLATE,
  GlobalSearchType.POWER_BI_TEMPLATE,
  GlobalSearchType.DASHLIST_TEMPLATE,
  GlobalSearchType.AUDIT_TEMPLATE,
  GlobalSearchType.BDE_VIEW,
  GlobalSearchType.FILE,
];

export const defaultGlobalSearchTypes = [...primarySearchTypes];

export function isGlobalSearchUIType(value: unknown): value is GlobalSearchUIType {
  return Object.values(GlobalSearchType).includes(value as GlobalSearchType);
}

export const requiredRightBySearchType: Partial<Record<GlobalSearchUIType, string>> = {
  [GlobalSearchType.SQDC_EVENT]: "sqdc.read",
  [GlobalSearchType.SQDC_ACTION]: "sqdc.read",
  [GlobalSearchType.KPI_BOARD]: "sqdc.read",
  [GlobalSearchType.KPI_TILE]: "sqdc.read",
  [GlobalSearchType.QUICK_TEMPLATE]: "sqdc.admin",
  [GlobalSearchType.WORKFLOW]: "sqdc.admin",
  [GlobalSearchType.CHART_TEMPLATE]: "sqdc.admin",
  [GlobalSearchType.POWER_BI_TEMPLATE]: "sqdc.admin",
  [GlobalSearchType.DASHLIST_TEMPLATE]: "sqdc.admin",
  [GlobalSearchType.AUDIT_TEMPLATE]: "audit.createAudit",
  [GlobalSearchType.BDE_VIEW]: "bde.admin",
  [GlobalSearchType.FILE]: "document.admin",
};
